import React from 'react';
import img from '../../assets/images/logo/Aertech_logo.png';

export default function ALogo() {
	return (
		<img
			className="a-logo"
			src={img}
			alt="Aertech logo"
		/>
	);
}



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.logo.js